const getters = {
  isLogin: state => state.user.isLogin,
  token: state => state.user.token,
  userid: state => state.user.userid,
  defaultImg: state => state.user.defaultImg,
  defaultHeadImg: state => state.user.defaultHeadImg
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js